import React, { createContext, useContext, useMemo } from 'react';
import useCurrentUser from '@API/auth/useCurrentUser';
import { User } from '@shared/types';

interface CurrentUserData {
  user: User;
  isLoading: boolean;
  isError: boolean;
}

interface CurrentUserProviderProps {
  children: React.ReactNode;
}

const CurrentUserContext = createContext<CurrentUserData>({
  user: {} as User,
  isLoading: false,
  isError: false
});

export const useCurrentUserContext = () => {
  const data = useContext(CurrentUserContext);

  return data;
};

const CurrentUserProvider = ({ children }: CurrentUserProviderProps) => {
  const { data: user, isLoading, isError } = useCurrentUser();

  const data: CurrentUserData = useMemo(
    () => ({
      user: user as User,
      isLoading,
      isError
    }),
    [user, isLoading, isError]
  );

  return (
    <CurrentUserContext.Provider value={data}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export default CurrentUserProvider;
